import { useState } from "react";
import { styled } from "@mui/material";
import { Outlet, useParams } from "react-router-dom";
import { Map } from "leaflet";

import { useMapPosition } from "hooks/mapHooks";

import { CollapsibeDrawer } from "components/layout/CollapsibleDrawer";
import { MapContent } from "components/map/MapContent";
import { Footer } from "components/layout/Footer";
import { MainWithFooterStyles } from "./MainWithFooterStyles";
import { SearchControl } from "components/map/search/SearchControl";
import { LoadingBox } from "components/map/LoadingBox";
import { JoyrideOverlayer } from "components/joyride/JoyrideOverlayer";

interface Props {}

export function MapLayout(props: Props) {
  const [mapRef, setMapRef] = useState<Map | null>();
  const [mapOverlayContainer, setMapOverlayContainer] =
    useState<HTMLDivElement | null>(null);

  const { uuid } = useParams();
  const [footerRef, setFooterRef] = useState<HTMLDivElement | null>(null);
  const { zoom, ...center } = useMapPosition();
  const [open, setOpen] = useState<boolean>(true);

  return (
    <>
      <Styles>
        <CollapsibeDrawer
          className={`panel ${open ? "open" : "closed"}`}
          onToggle={() => setOpen(!open)}
          open={open}
          padding={0}
          variant="persistent"
          elevation={0}
        >
          {mapRef && footerRef && mapOverlayContainer && (
            <Outlet
              context={{
                mapRef: mapRef,
                footerRef: footerRef,
                mapOverlayContainer: mapOverlayContainer,
              }}
            />
          )}
        </CollapsibeDrawer>
        <MapContent
          center={center}
          zoom={zoom}
          setMapRef={setMapRef}
          uuid={uuid}
        >
          <JoyrideOverlayer data-tour="step-1" />
          <LoadingBox setMapOverlayContainer={setMapOverlayContainer} />
          <SearchControl position="topright" />
        </MapContent>
      </Styles>
      <Footer setFooterRef={setFooterRef} />
    </>
  );
}

const Styles = styled(MainWithFooterStyles)`
  .panel {
    display: flex;
    justify-content: stretch;
    transition: flex-basis 320ms ease-out;
    min-width: 400px;

    flex: 1 0 20%;
    &.closed {
      flex: 0 1 0%;
      min-width: 0;
    }
  }
`;
